import { useMemo } from "react";
import { connectSearchBox } from "react-instantsearch-dom";
import { PropTypes } from "prop-types";

import useResponsiveWithHydrationFix from "../../../../hooks/useResponsiveWithHydrationFix";

import IconSearch from "@svgs/search.svg";
import IconClose from "@svgs/close-delete.svg";

function getValueAutoCompleteFromHits(currentRefinement, hits = []) {
  // Get first full word based on hits results
  if (!currentRefinement || !hits.length) return "";

  const fullTitle = hits[0]?.contentful?.title?.toLowerCase() || "";
  const currentSearch = currentRefinement.toLowerCase();
  const predictedWord = fullTitle.split(" ").find((word) => word.startsWith(currentSearch)) || "";
  if (!predictedWord || predictedWord === currentSearch) return "";
  const completedWord = currentRefinement + predictedWord.substring(currentSearch.length);
  return completedWord;
}

function AutoCompleteInput({ value, onChange, valueAutocomplete = "" }) {
  return (
    <div className="ml-[10px] w-full relative">
      {value && valueAutocomplete && (
        <div className="flex absolute">
          <div className="typo-text">{value}</div>
          <div className="text-dark-grey">{valueAutocomplete.split(value)?.[1] || ""}</div>
        </div>
      )}
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => e.key === "Tab" && valueAutocomplete && onChange(valueAutocomplete)}
        type="text"
        className="border-none bg-transparent flex-1 outline-none p-0 w-full text-base leading-[22px]"
        autoFocus
      />
    </div>
  );
}

function CustomSearchBox({ currentRefinement, refine, closeSearch, hits }) {
  const valueAutocomplete = useMemo(
    () => getValueAutoCompleteFromHits(currentRefinement, hits),
    [currentRefinement, hits]
  );

  const closeButton = useResponsiveWithHydrationFix(
    null,
    <button type="button" className="ml-[30px]" onClick={closeSearch}>
      <IconClose fill="none" stroke="#000000" width="16px" height="16px" />
    </button>
  );

  return (
    <div className="flex flex-row items-center mb-[15px] mobile:mx-[15px]">
      <div className="flex flex-row items-center w-full bg-light-grey rounded-[4px] h-[40px] px-[15px]">
        <IconSearch width="17" height="17" fill="none" stroke="#898786" />
        <AutoCompleteInput
          value={currentRefinement}
          onChange={refine}
          valueAutocomplete={valueAutocomplete}
        />
      </div>
      {closeButton}
    </div>
  );
}

CustomSearchBox.propTypes = {
  currentRefinement: PropTypes.string,
  refine: PropTypes.func,
  closeSearch: PropTypes.func,
};

export default connectSearchBox(CustomSearchBox);
